import * as React from 'react';

import { Button, Row } from '@rematter/ui-web';
import { useSetAtom } from 'jotai';

import { $submitActionResponse } from '../../_state/chatInput.state';

interface ActionOption {
  label: string;
  value: string;
}

interface ActionButtonsProps {
  options: ActionOption[];
}

//
// ⚛️ ⚛️ ⚛️ ACTION BUTTONS ⚛️ ⚛️ ⚛️
//
export const ActionButtons = ({ options }: ActionButtonsProps) => {
  // States
  const [selected, setSelected] = React.useState<string | null>(null);

  // Atoms
  const submitActionResponse = useSetAtom($submitActionResponse);

  // Callbacks
  const handleSelect = React.useCallback(
    (option: ActionOption) => {
      if (selected !== null) return;
      setSelected(option.value);
      void submitActionResponse(option);
    },
    [selected, submitActionResponse],
  );

  return (
    <Row gap2 className="@ActionButtons mt-2 flex-wrap">
      {options.map((option) => (
        <Button
          key={option.value}
          variant="outline"
          onPress={() => handleSelect(option)}
          isDisabled={selected !== null}
          className="rounded-lg! font-medium normal-case rac-hover:border-primary! rac-hover:text-primary! rac-disabled:opacity-40!"
        >
          {option.label}
        </Button>
      ))}
    </Row>
  );
};
